import { render, staticRenderFns } from "./EmployeesOverviewView.vue?vue&type=template&id=d504d730&"
import script from "./EmployeesOverviewView.vue?vue&type=script&lang=js&"
export * from "./EmployeesOverviewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports